import LocationPanel from './LocationPanel';
export default LocationPanel;